<template>
  <div class="position-relative">
    <b-form-input
      v-model="selected_value"
      @click.self="is_close = false"
      @blur.native="handleBlur"
      autocomplete="off"
      maxlength="4"
      @keypress.native="handleKeypress"
      @input="error = null"
      :state="isInvalid(errorKey)"
      :class="['inputdropdown-text', { 'bg-disabled': enabled  }]"
      placeholder="0"
      :disabled="enabled||selected_value==='No Limit'">
    </b-form-input>
    <div
      id="options-container"
      class="bg-white position-absolute w-100" v-if="!is_close">
      <div v-for="(value, index) in acceptedOrderOptions" :key="`value_${index}`"
        class="px-3 py-2 cursor-pointer" @click.self="setSelectedValue(value)">
        {{ value }}
      </div>
    </div>
    <b-form-invalid-feedback :force-show="isInvalid(errorKey)">{{ errorMessage(`${errorKey}`) }}</b-form-invalid-feedback>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PreOrderingAcceptedOrderInputDropdown",
  props: ["selectedValue", "errorKey", "enabled"],
  data() {
    return {
      selected_value: null,
      is_close: true,
      max_limit: 5000,
      error: null
    }
  },
  computed: {
    ...mapGetters({
      errors: 'orderFulfillment/errors'
    }),
    acceptedOrderOptions() {
      const options = Array.from({ length: 100 }, (x, k) => k + 1);
      return options.map(value => value.toString()).filter(value => value.includes(Number(this.selected_value)))
    }
  },
  methods: {
    ...mapMutations({
      setErrors: 'orderFulfillment/set_errors'
    }),
    setSelectedValue(value) {
      this.selected_value = value;
      this.$emit("setValue", value );
      this.$nextTick(() => {
        this.is_close = true;
      });
    },
    handleBlur() {
      setTimeout(() => {
        const error = {};
        if (this.selected_value > this.max_limit) {
          error[this.errorKey] = "Invalid Input for Accepted Order. It only allows 1-5000 only.";;
          this.selected_value = null;
          this.setSelectedValue(null);
          this.setErrors(error);
        } else {
          this.setErrors(null);
        }
        this.$nextTick(() => {
          if (this.selectedValue !== this.selected_value) this.setSelectedValue(this.selected_value);
          this.is_close = true;
        });
      }, 200);
    },
    handleKeypress(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    isNotNumeric(input) {
      return /[^0-9\s]+/g.test(input);  
    },
    isInvalid(key) {
      return this.errors && this.errors[key]
        ? false
        : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key]
        ? this.errors[key]
        : null;
    },
  },
  watch: {
    selectedValue(value) {
      this.selected_value = value;
    },
  }
}
</script>

<style lang="scss" scoped>
.inputdropdown-text {
  background: url('../../assets/images/caret-down.svg') no-repeat center right 10px;
  &.bg-disabled {
    background-color: #E9EBED;
  }
}
.form-control:disabled{
  background-color: ghostwhite;
  color:#e8ebec;
}
.form-control:focus{
  box-shadow: 0 0 0 .2rem rgba(255, 107, 0, .25) !important;
}
#options-container {
  z-index: 2;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}
.cursor-pointer:hover{
  background: rgb(118,118,118) !important;
  color: white;
}
</style>
